import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { NewsItems } from '@/types/news'
import { formatEpoch } from '@/utils/formatter'

const NewsCard: FC<{ data: NewsItems }> = ({ data }) => {
  const { t } = useTranslation()
  const router = useRouter()
  return (
    <>
      <article className='group relative hidden flex-row-reverse overflow-hidden rounded-xl border border-form-border before:absolute before:bottom-0 before:left-0 before:z-10 before:h-1 before:w-0 before:bg-orange before:transition-all before:duration-300 hover:border-transparent hover:shadow-card hover:before:w-full lg:block lg:flex-col'>
        <div className='h-[205px] w-full overflow-hidden'>
          <ImageByWidthDevice
            images={data.imageFiles}
            alt={data.imageFiles.desktop.fileName ?? ''}
            className='h-[205px] w-full object-cover object-center transition-all duration-300 group-hover:scale-125'
          />
        </div>

        <div className='flex w-full flex-col gap-3.5 bg-white px-4 py-3.5'>
          <Link href={`/media/press/${data.slug}`}>
            <h4 className='line-clamp-2 cursor-pointer break-all text-sm font-semibold leading-normal tracking-[-0.6%]'>
              {data.title}
            </h4>
          </Link>

          <div className='flex items-center justify-between border-t border-t-accent-light/10 pt-3'>
            <p className='text-xs leading-normal text-gray-2'>
              {formatEpoch(Number(data.createdAt), 'EEEE, dd LLLL yyyy | T', router.locale)}
            </p>

            <Link href={`/media/press/${data.slug}`}>
              <span className='kek-arrow-right cursor-pointer text-[24px]' />
            </Link>
          </div>
        </div>
      </article>

      <article className='flex flex-col gap-2 border-b-[1px] border-b-neutral-border pb-6 lg:hidden'>
        <div className='flex h-15 justify-between gap-4'>
          <Link href={`/media/press/${data.slug}`}>
            <h4 className='line-clamp-3 w-full cursor-pointer text-[12px] font-bold leading-normal text-dark'>
              {data.title}
            </h4>
          </Link>

          <ImageByWidthDevice
            images={data.imageFiles}
            alt={data.imageFiles.desktop.fileName ?? ''}
            className='h-15 min-w-[106px] rounded-[4px] object-cover object-center'
          />
        </div>

        <div className='flex items-baseline'>
          <p className='flex-1 text-xs leading-normal text-gray-2'>
            {formatEpoch(Number(data.createdAt), 'EEEE, dd LLLL yyyy | T', router.locale)}
          </p>

          <Link href={`/media/press/${data.slug}`}>
            <span className='cursor-pointer text-xs font-semibold leading-normal text-red'>{t('common:readMore')}</span>
          </Link>
        </div>
      </article>
    </>
  )
}

export default NewsCard
